// extracted by mini-css-extract-plugin
module.exports = {"container":"placementSlider_container__2UapK","collapsableSection":"placementSlider_collapsableSection__p1x8V","title":"placementSlider_title__1vJos","collapse":"placementSlider_collapse__2mgvs","arrow":"placementSlider_arrow__1siL-","seeProject":"placementSlider_seeProject__hKpNx"};
    if(module.hot) {
      // 1790670304600
      var cssReload = require("!../../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  